import { useAppSelector } from 'shared/lib';

import type { TCreditFormDictionaryName } from 'entities/creditForm';
import { selectCreditFormDictionaries } from 'entities/creditForm';

export const useDictionaries = (dictionaryNames: TCreditFormDictionaryName[]) => {
  return useAppSelector(selectCreditFormDictionaries(dictionaryNames));
};
